import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import MuiGrid from "@mui/material/Unstable_Grid2";
import classNames from "classnames";
export const Grid = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    className,
    children,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(MuiGrid, _extends({
    ref: ref,
    className: classNames("prmbl-grid", className)
  }, otherProps), children);
});
Grid.displayName = "Grid";
export default Grid;